import React from 'react';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { ContenedorForm, HeaderForm, CuerpoForm, TituloForm,Row,ContainerCol  } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../../componentes/componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import moment from 'moment';
import global_axios  from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';

import 'rc-tooltip/assets/bootstrap.css';
import {  formatearNumeroEntero,formatearFechaMoment_a_String,formatearNumeroDecimal } from '../../funciones_globales/format';

import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker'
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
const ContainerAlineado = styled.div`
  display: inline;
`;

const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;

const LabelTotales = styled.label`
	display: inline-block;
	font-size: 10px;
	color: green;
`;
const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 9px;
	font-weight: bold;
	align-text: right;
`;
// const LabelTipoProf = styled.label`
//   display: inline;
//   font-size: 10px;
//   color: green;    
// `;

// const ValueForm = styled.span`
// 	display: inline-block;
// 	font-size: 12px;
// `;
const ContenedorBoton = styled.div`
  padding-top: 17px;  
  @media (max-width: 991px) {
    padding-top: 0px;
  }
`;
class FormVende02  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            perfilObject:{},
            vendedores:[],
            isVendedor:true,
            fechaProcesoString:'',
            opcion_filtrado_sel:null,
            vendedor_sel:null,
            fecha_inicial: null,
            fecha_final: null,   
            formaPago:[],
            total: parseFloat(0.00),
            cantidadPedidosMoviles: parseFloat(0.00),
            detalleProforma: [],
            visibleDatesPicker:false,
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            colsDefDetProforma: [
                {   header: "Pedido",
                    field: "Pedido",
                    width: 90,
                    type: "string"
                },
                {   header: "Cliente",
                    field: "Nombre",
                    width: 180,
                    type: "string"
                },     
                {   header: "Vendedor",
                    field: "Vendedor",
                    width: 140,
                    type: "string"
                },                     
                {   header: "Fecha",
                    field: "Fecha",
                    width: 130,
                    type: "string"                               
                },
                
                {   header: "Dscto.Linea",
                    field: "Descuento",
                    width: 77,
                    type: "num_decimal"
                },
                {   header: "Dscto.Plazo",
                    field: "TotalDsctoPlazo",
                    width: 77,
                    type: "num_decimal"
                },
                {   header: "Sub Total",
                    field: "SubDescuento",
                    width: 120,
                    type: "num_decimal"
                },
                { header: 'Iva',
                    field: 'Iva',
                    width: 77,
                    type: 'num_decimal'            
                },
                {   header: "Total",
                    field: "Total",
                    width: 120,
                    type: "num_decimal"
                },
                
                {   header: "Forma Pago",
                    field: "FormaPago",
                    width: 120,
                    type: "string"
                },
                {   header: "Termino Pago",
                    field: "TerminoPagoDescrip",
                    width: 150,
                    type: "string"
                },
                {   header: "Estado",
                    field: "StatusDescrip",
                    width: 120,
                    type: "string"
                },
            ],
            opcionesFiltrado:[
                {
                    label:"Semana Corriente",
                    value:1
                },
                {
                    label:"Semana Anterior",
                    value:2
                },
                {
                    label:"Mes Corriente",
                    value:3
                },
                {
                    label:"Periodo",
                    value:4
                }
            ],
        };

       
        this.gridDetProformaOptions = {
            context: {
                componentParent: this
            }, 
            enableColResize: true,
            enableCellChangeFlash: true,
            enableSorting: true,
            enableFilter: true,
            
            // onCellDoubleClicked: ((event)=>{        
            //     if(event.column.colId==='Articulo' || event.column.colId==='Descripcion' || event.column.colId==='StockDisponible'){
            //         let documento = event.data;
            //         this.generarConsultaDetalleArticuloPedido(documento);
            //     }
            // }),
            
            rowSelection: 'single',
            rowDeselection: 'true',
            singleClickEdit: true,
            suppressScrollOnNewData: true,
            getRowStyle: (params) =>{		
                switch (params.data.Status) {
                    case 'N':
                        return {'background-color': '#20ABDD'}; 
                    case 'E':
                        return {'background-color': '#35F39F'}; 
                    case 'T':
                        return {'background-color': '#F2F68D'}; 
                    default:
                        return null
                }		
				
			}
      
        };
        this.onGridDetProformaReady = this.onGridDetProformaReady.bind(this);
        this.immutablePush = this.immutablePush.bind(this);
        this.immutableDelete = this.immutableDelete.bind(this);
        this.getUserPedidosMoviles = this.getUserPedidosMoviles.bind(this)
        this.handleDeletePedido = this.handleDeletePedido.bind(this)
        this.generarConsulta = this.generarConsulta.bind(this)
        this.changeFilterOption = this.changeFilterOption.bind(this)
        this.changeFilterVendedorOption = this.changeFilterVendedorOption.bind(this)
        this.handlePrintPedido = this.handlePrintPedido.bind(this)
          
    }
    changeFilterVendedorOption(value){
        this.setState({
            vendedor_sel:value!==null?value.value:null 
        })
    }
    handlePrintPedido(){
        let filasSeleccionadas = this.gridDetProformaApi.getSelectedRows();
          console.log("filaSeleccionadaaaaaaa", filasSeleccionadas)
          console.log(this.state.perfilObject)
          if (this.state.detalleProforma.length===0){
            alert('No existen Pedidos');
            return;
          }
    
          if (filasSeleccionadas[0]===undefined){
            alert('Debe seleccionar el pedido que desee imprimir.')
            return;
          }
    
          let pedido = filasSeleccionadas[0];
          var parametros = ""
          parametros = '&rpt=149&param1='+pedido.Pedido+'&param2='+this.state.perfilObject.Id
          console.log(parametros)
          visualizarReporteEnPdf(parametros)
          
    }
    changeFilterOption(value){
        let fechaProceso = getFechaProcesoPorModulo('11');
        let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY");
        let fecha_inicio_semana= this.getMonday(fecha_proceso_moment);
        let fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
        let copia_fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
        let fecha_final = copia_fecha_inicial.add(5,'days');

        const filterOption =value!==null?value.value:null 
        let visibleDatesPicker= false
        switch (filterOption) {
            case 2:
                //SEMANA ANTERIOR
                let fecha_inicial_semana_anterior = moment(fecha_inicio_semana, "DD/MM/YYYY").subtract('1','w')
                let copia_fecha_inicial_semana_anterior= moment(fecha_inicio_semana, "DD/MM/YYYY").subtract('1','w')
                fecha_inicial=fecha_inicial_semana_anterior
                fecha_final = copia_fecha_inicial_semana_anterior.add(5,'days');
                break;
            case 3:
                //MES CORRIENTE
                const startOfMonth = moment(fecha_proceso_moment, "DD/MM/YYYY").startOf('month');
                const endOfMonth   = moment(fecha_proceso_moment, "DD/MM/YYYY").endOf('month');
                fecha_inicial= startOfMonth
                fecha_final=endOfMonth
                
                break;
            case 4:
                visibleDatesPicker=true
                fecha_inicial = fecha_proceso_moment
                fecha_final = fecha_proceso_moment
                break;
            default:
                break;
        }
        this.setState({
            opcion_filtrado_sel:filterOption, fecha_inicial:fecha_inicial, fecha_final:fecha_final, visibleDatesPicker:visibleDatesPicker
        })
    }
    
    immutablePush(array, newItem){
        return [ ...array, newItem ];
    }
    immutableDelete(arr, index){
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }
   
    onGridDetProformaReady(params){
        this.gridDetProformaApi = params.api;
        this.gridDetProformaColumnApi = params.columnApi;
    }   

    componentDidMount(){
        const userName = localStorage.usuario

        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('1103'),
            this.getVendedores()
         ])
        .then(() => {
            let fechaProceso = getFechaProcesoPorModulo('11');
            let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY");
            let fecha_inicio_semana= this.getMonday(fecha_proceso_moment);
            let fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
            let copia_fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
            let fecha_final = copia_fecha_inicial.add(5,'days');
            let perfil = JSON.parse(localStorage.getItem("perfil"))
            console.log("VENDEDOR PERFIL", perfil)
            let isVendedor = perfil.Nomb === "VENDEDOR";
            this.setState({fecha_inicial: fecha_inicial, fecha_final: fecha_final, opcion_filtrado_sel:1, fechaProcesoString: fecha_proceso_moment.format("DD/MM/YYYY"), isVendedor, perfilObject:perfil },()=>{
                this.getUserPedidosMoviles(userName, isVendedor)
            })
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('1103');
    }
    
    getVendedores(){
        this.props.cambiar_VisualizacionLoading(true);
        
        global_axios({
                method: 'GET',
                url: `/vendedores`
                })
                .then((response)=> {
                   console.log("VENDEDORES", response)
                    this.props.cambiar_VisualizacionLoading(false);
                    const vendedores = response.data.map((vend)=>{ return {value:vend.Codigo, label: `${vend.Descripcion} (${vend.Codigo})` } })
                    this.setState({
                        vendedores
                    })
            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
    }
   
    getUserPedidosMoviles(userName, isVendedor){
        console.log("USERNAME", userName)
        console.log("ISVENDEDOR", isVendedor )
        this.props.cambiar_VisualizacionLoading(true);
        let QueryString = "";
		QueryString += "?fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
		QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");
        QueryString += "&isVendedor="+isVendedor;
        QueryString += "&vendedorSelected="+this.state.vendedor_sel;
        global_axios({
                method: 'GET',
                url: `/pedidosMoviles/all/${userName}${QueryString}`
                })
                .then((response)=> {
                    let total = 0
                    const pedidos = response.data
                    pedidos.forEach(element => {
                        element.Fecha = element.Fecha.split('T')[0]
                        element.FormaPago = element.FormaPago === 'CR'?'CREDITO':'CONTADO'
                        total = total + element.SubDescuento
                        element.Nombre = `${element.Nombre}-${element.Cliente}`
                    });
                    this.props.cambiar_VisualizacionLoading(false);
                    this.setState({
                        detalleProforma:pedidos,
                        total:total,
                        cantidadPedidosMoviles:pedidos.length
                    })
            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
    }

    handleDeletePedido(){

        // if (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.esModificable===true) || (this.state.modifProformaTransito===true)){
        
          let filasSeleccionadas = this.gridDetProformaApi.getSelectedRows();
          console.log("filaSeleccionadaaaaaaa", filasSeleccionadas)
          if (this.state.detalleProforma.length===0){
            alert('No existen Pedidos');
            return;
          }
    
          if (filasSeleccionadas[0]===undefined){
            alert('Debe seleccionar el pedido que desee eliminar.')
            return;
          }
    
          let pedido = filasSeleccionadas[0];
    
        //   if ((!itemProforma.EsEditable) && itemProforma.EsPromocion!=='*'){
        //    this.gridDetProformaApi.stopEditing(true);
        //     alert('La eliminación de este artículo no está permitida.');
        //     return;
        //   }
    
          let eliminar = window.confirm(`¿Está seguro de eliminar el pedido: ${pedido.Pedido}?`);
           if (eliminar){
              
              this.quitarPedidoDeProforma(pedido)  
              
            }
        // }else{
        //   alert('La modificación de esta proforma no está permitida.');
        // }
    }
    quitarPedidoDeProforma(itemProf){
        let indiceEliminar;
        for(indiceEliminar=0; indiceEliminar<this.state.detalleProforma.length; indiceEliminar++){
            if (this.state.detalleProforma[indiceEliminar].Pedido === itemProf.Pedido){
                break;
            }
        }
       
        this.props.cambiar_VisualizacionLoading(true);
            let query = "?id="+itemProf.Pedido
            global_axios({
            method: 'GET',
            url: '/pedidosmoviles/anular/pedido/de/itera/id'+query
            }).then((response)=>{ 
                alert('Pedido Número '+itemProf.Pedido+' anulado con exito.') 
                this.setState({ detalleProforma: this.deleteItemArray(this.state.detalleProforma, indiceEliminar) });
                //QUITAR ESA VAINA DEL ARRAY
                this.props.cambiar_VisualizacionLoading(false)
            }).catch((err)=>{
                this.props.cambiar_VisualizacionLoading(false)
                const errm = err!==null && err !==undefined ? 
                    err.response !== null && err.response !== undefined ? 
                    err.response.data!== null && err.response.data!== undefined?   err.response.data.msg : '' : '' : ''
                alert( errm)
            })
        
    }
    deleteItemArray (arr, index) {
        let indice = formatearNumeroEntero(index);
        let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
        
        return arr_tmp;
    }
    getMonday( fecha ) {
        var date= new Date(fecha);
        var day = date.getDay() || 7;  
        if( day !== 1 ) 
            date.setHours(-24 * (day - 1)); 
        return date;
    }
    generarConsulta(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        
        // let fechaProceso = getFechaProcesoPorModulo('11');
        // if(this.validacionFechaTrabajo(fechaProceso, this.state.fecha_final)===false){
        //     errorAnio = true;
        //     continuar = false;
        //     error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        // }

        // if(this.validacionFechaTrabajo(fechaProceso, this.state.fecha_inicial)===false){
        //     errorAnio = true;
        //     continuar = false;
        //     error=error+'- La fecha desde no esta dentro del año vigente.\n';
        // }
        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fecha_final.diff(this.state.fecha_inicial, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fecha_final)+'\n';
        }
        //Validación consulta solo de 31 días
        if(this.state.fecha_final.diff(this.state.fecha_inicial, 'days')>31){
            continuar = false;
            error=error+'- Las fechas deben encontrarse en un rango menor o igual a 31 días';
        }
        if(continuar === true){
            const userName = localStorage.usuario
            this.getUserPedidosMoviles(userName, this.state.isVendedor)
        }else{
            alert(error);
        }
    }
   
    
   

    render(){
        return (
            <ContenedorForm porc_ancho={92}>
            <HeaderForm>
                <ContainerAlineado>
                    <TituloForm>Consulta Pedidos Moviles</TituloForm>
                    <LabelCabecera>Fecha Proceso: {this.state.fechaProcesoString===undefined?'':this.state.fechaProcesoString}</LabelCabecera>
                </ContainerAlineado>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-xs-12 col-sm-12'>{/*col-sm-offset-4 col-sm-pull-4 - col-sm-offset-4 col-sm-pull-4*/}
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-1' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Opcion de filtrado:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-2' margen_arriba='15' margen_abajo='4'>
                                    <ReactSelect   options={ this.state.opcionesFiltrado } value={this.state.opcion_filtrado_sel}
                                    func_onChange={(value)=>{this.changeFilterOption(value)} }/>
                                </ContainerCol>
                                {
                                    
                                    !this.state.isVendedor?
                                    <div>
                                        <ContainerCol className='col-xs-12 col-sm-1' margen_arriba='15' margen_abajo='4'>
                                            <LabelForm>Vendedor:</LabelForm>
                                        </ContainerCol>
                                        <ContainerCol className='col-xs-12 col-sm-2' margen_arriba='15' margen_abajo='4'>
                                            <ReactSelect   options={ this.state.vendedores } value={this.state.vendedor_sel}
                                            func_onChange={(value)=>{this.changeFilterVendedorOption(value)} }/>
                                        </ContainerCol>
                                        <ContainerCol className='col-xs-12 col-sm-2' margen_arriba='15' margen_abajo='4'>
                                         <LabelTotales >Para consulta de todos los vendedores dejar en blanco la Caja VENDEDOR</LabelTotales>
                                        </ContainerCol>
                                    </div>
                                  
                                    :
                                    null
                                }
                               
                                {this.state.visibleDatesPicker === true?
                                <div>
                                    <ContainerCol className='col-xs-12 col-sm-1' margen_arriba='15' margen_abajo='8'>
                                    <LabelForm>Desde:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-2 ' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fecha_inicial} func_onChange={(fechaEscogida)=>{this.setState({fecha_inicial: fechaEscogida});}}/>
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-1' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Hasta:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-2' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fecha_final} func_onChange={(fechaEscogida)=>{this.setState({fecha_final: fechaEscogida});}}/>
                                </ContainerCol>
                                </div>:null
                            
                            }
                                
                                
                                <ContainerCol className='col-xs-12 col-sm-3'margen_arriba={15}>
                                        <div className='btn-group pull-right'>                            
                                            <button type='button' className='btn btn-info btn-sm'  onClick={this.generarConsulta}><i className="fa fa-search" aria-hidden="true"/>Buscar</button>  
                                        </div>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>
                    </Row>
                    {/* <Row>
                        <ContainerCol className='col-sm-12 col-xs-12' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ContenedorBoton>
                                
                                    <div className='btn-group pull-left' >
                                        <button type='button' className='btn btn-danger btn-sm' onClick={this.handleDeletePedido}>Anular Pedido <i className='fa fa-window-close'></i></button>
                                    </div>
                                
                            </ContenedorBoton>
                        </ContainerCol>
                    </Row> */}
                    <Row>
                        <ContainerCol className='col-sm-12 col-xs-12' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ContenedorBoton>
                                
                                    <div className='btn-group pull-left' >
                                        <button type='button' className='btn btn-danger btn-sm' onClick={this.handlePrintPedido}>Imprimir Pedido <i className='fa fa-print'></i></button>
                                    </div>
                                
                            </ContenedorBoton>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <div className='col-sm-12 col-xs-12'>
                            <Row>
                                <div className='col-sm-12 col-xs-12'>
                                    <AgGridRender altura='200px' data={this.state.detalleProforma} columnas={this.state.colsDefDetProforma}
                                    gridOptions={this.gridDetProformaOptions} onGridReady={this.onGridDetProformaReady}/>
                                </div>
                            </Row>
                            
                        </div>    
                    </Row>  
                    <Row>
                        <div className='col-sm-2 col-xs-12'>
                            <LabelTotales>Cantidad de pedidos:</LabelTotales>
                            <LabelValorTotales>{formatearNumeroEntero(this.state.cantidadPedidosMoviles)}</LabelValorTotales>
                        </div>
                        <div className='col-sm-2 col-xs-12'>
                            <LabelTotales>Total:</LabelTotales>
                            <LabelValorTotales>{formatearNumeroDecimal(this.state.total)}</LabelValorTotales>
                        </div>
                    </Row>
                    <Row>
                        <div className="col-sm-2 col-xs-2 form-inline"  style={{backgroundColor:'#20ABDD', width:'50px', height:'10px', marginLeft:15, display:'inline-block'}}>
                        </div>  
                        <div className="col-sm-2 col-xs-2  form-inline" style={{ display:'inline-block'}}>
                            <p>Nuevos</p>
                        </div>  
                        <div className="col-sm-2 col-xs-2 form-inline"  style={{backgroundColor:'#35F39F', width:'50px', height:'10px', marginLeft:15, display:'inline-block'}}>
                        </div>  
                        <div className="col-sm-2 col-xs-2  form-inline" style={{ display:'inline-block'}}>
                            <p>Enviados</p>
                        </div> 
                        <div className="col-sm-2 col-xs-2 form-inline"  style={{backgroundColor:'#F2F68D', width:'50px', height:'10px', marginLeft:15, display:'inline-block'}}>
                        </div>  
                        <div className="col-sm-2 col-xs-2  form-inline" style={{ display:'inline-block'}}>
                            <p>Transferidos</p>
                        </div>  
                    </Row>
                   
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        tipo_usuario: state.sesion.valoresSesionForm.TipoUsuario,
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormVende02);